import owd from 'owd/owd';
import _ from 'underscore';
//import 'lib/typeahead';

export default class Search extends owd.Component {
	init() {
        this.currQuery = '';
        this.searchInput = this.$element.find('.search-input');
        this.submitButton = this.$element.find('.button--search');
        this.searchResults = this.$element.find('.search-results');
        
		this.bind();
	}

    reset() {
        this.searchResults.removeClass('is-visible').html('');
    }
    
    searchFor(query) {
        if(this.currQuery != query) {
        //    app.ajax.abortXhr();
            this.currQuery = query;

            if(query.length) {
                var baseHref = this.dom.$body.data('base-href');

                //$('.popup-search form').addClass('loading');
                this.searchResults.addClass('is-visible');
                this.searchResults.html('<li>Szukanie...</li>');

                $.ajax({
                    url: baseHref + 'wp-json/wp/v2/search/' + encodeURIComponent(query),
                    type: 'get',
                    data: { lang: this.dom.$html.attr('lang') },
                    dataType: 'json'
                }).done((response) => {
                    //$('.popup-search form').removeClass('loading');
                    this.searchResults.addClass('is-visible');
                    this.renderResults(response, query);
                }).fail((req, status, err) => {
                    if (status != 'abort') {
                        this.searchResults.removeClass('is-visible');
                        console.error(req, status, err);
                        // alert('Błąd komunikacji z serwerem. Spróbuj ponownie za chwilę. Jeśli problem nie ustąpi, skontaktuj się z administracją serwisu.');
                    }
                });
            } else {
                this.reset();
            }
        }
    }
    
    resultTemplate(data) {
        const link = data.link;
        const title = data.title.rendered;
        
        const item = document.createElement('li');
        
        $(item).addClass('search-results-item');
        $(item).html(`<a href="${link}" class="search-results-link">${title}</a>`);
        
        return item;
    }
    
    renderResults(response, query) {
        const docFragment = document.createDocumentFragment();
        
        response.forEach((responseItem) => {
            docFragment.appendChild(this.resultTemplate(responseItem));
        });

        this.searchResults.html(docFragment);
    }
    
	bind() {
        this.on('submit', (e) => {
            //e.preventDefault();
            
            //this.searchFor(this.searchInput.val());
        });
        
        this.on('input', this.searchInput, _.throttle((e) => {
            this.searchFor(this.searchInput.val());
        }, 800));
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('search', {
	component: Search
});
